// Friends wall, add-by-code, pending requests, and daily reactions.
// Referral code doubles as the friend-add code so there's one shareable
// string per user.

import { call } from './core';
import type {
  FriendRequestByCodeResult,
  FriendshipOut,
  WallResponse,
} from './types';

export const socialApi = {
  requestFriendByCode: (code: string) =>
    call<FriendRequestByCodeResult>('/friends/request-by-code', {
      method: 'POST',
      body: JSON.stringify({ code }),
    }),
  listPendingFriends: () =>
    call<FriendshipOut[]>('/friends/pending'),
  acceptFriendship: (friendshipId: string) =>
    call<FriendshipOut>(
      `/friends/${encodeURIComponent(friendshipId)}/accept`,
      { method: 'POST', body: '{}' },
    ),
  rejectFriendship: (friendshipId: string) =>
    call<void>(`/friends/${encodeURIComponent(friendshipId)}/reject`, {
      method: 'POST',
      body: '{}',
    }),
  unfriendByUser: (userId: string) =>
    call<void>(`/friends/by-user/${encodeURIComponent(userId)}`, {
      method: 'DELETE',
    }),
  getFriendsWall: (date?: string) =>
    call<WallResponse>(`/friends/wall${date ? `?date=${date}` : ''}`),
  reactToFriend: (userId: string, type: 'like' = 'like') =>
    call<{
      to_user_id: string;
      reaction: string;
      reaction_date: string;
      created_at: string;
    }>(`/friends/${encodeURIComponent(userId)}/react`, {
      method: 'POST',
      body: JSON.stringify({ type }),
    }),
};
